import React from "react";
// import { TextFieldProps } from "@mui/material";

import FormikInput from "./FormikInput";
import FormikAutocomplete from "./FormikAutocomplete";
import FormikDatePicker from "./FormikDatePicker";

// Types
/* import { AutocompleteProps } from "./FormikAutocomplete";
import { FormikDatePickerProps } from "./FormikDatePicker";

type ControlProp = {
    control: "input" | "autocomplete" | "datepicker";
}
type FormikInputProps = TextFieldProps & ControlProp;
type FormikAutocompleteProps = AutocompleteProps & ControlProp;
type DatePickerProps = FormikDatePickerProps & ControlProp; 
type Props = FormikInputProps | FormikAutocompleteProps | DatePickerProps; */

const FormikControl = (props: any) => {
  const { control, ...otherProps } = props;
  switch (control) {
    case "input":
      return <FormikInput {...otherProps} />;
    case "autocomplete":
      return <FormikAutocomplete {...otherProps} />;
    case "datepicker":
      return <FormikDatePicker {...otherProps} />;
    default:
      return null;
  }
};

export default FormikControl;
